// extracted by mini-css-extract-plugin
module.exports = {"wallex__subtext":"wallex-subtext_wallex__subtext__0PkGX"};